<template>
  <div id="app"
       class="app">
    <router-view></router-view>
    <Biao></Biao>
    <Router class="router"
            v-if="$route.meta.keepAlive"></Router>
  </div>
</template>

<script>
import Router from '@/components/Router.vue'
import Biao from '@/components/Biao.vue'
import { showLoading, hideLoading } from './utils/loading'
import axios from "axios"

export default {
  name: 'App',
  components: {
    Router,
    Biao
  },
  mounted () {
    this.$http.get('/api/ssm/Api/listCity_countsByname')
    .then((r) => {
      hideLoading()//关闭加载
      console.log(r.data.items);
      localStorage.setItem("date", JSON.stringify(r.data.items));
    })
    .catch(function (error) {
      hideLoading()//关闭加载
      //失败了调用reject()
      reject(error)
    })
  },
}
</script>

<style lang="less">
.app {
  background: url(https://www.bjdzhl.com/app/getFileURL/file/pages/home/bj.jpg)
    no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;

  position: relative;
  width: 100vw;
  height: 100vh;
  .router {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 10;
    
  }
}
</style>
